<template>
  <div class="public-head" >
    <el-container>
      <el-header>
        <el-row type="flex" class="row-bg" justify="space-between" style="flex-wrap: wrap;">
          <el-col :span="7" class="moblie-title">
            <div class="grid-content bg-purple"><h1>饲料原料和饲料添加剂查询数据库</h1></div>
          </el-col>
          <el-col :span="5" class="moblie-search display-flex align-center justify-between">
            <div class="grid-content bg-purple addBtn">
              <el-form :inline="true" :model="ruleFormSearch" :rules="rulesSearch" ref="ruleFormSearch" label-width="100px" class="demo-ruleForm" >
                <el-row  type="flex" class="row-bg" justify="space-between">
                    <el-col :span="18">
                      <el-form-item prop="input">
                        <el-input v-model="ruleFormSearch.input" placeholder="请输入关键词" @keyup.enter.native="submitForm('ruleFormSearch')"></el-input>
                      </el-form-item>
                      </el-col>
                    <el-col :span="6">
                      <el-button type="primary" @click="submitForm('ruleFormSearch')">搜索</el-button>
                    </el-col>
                </el-row>
              </el-form>

            </div>
            <div class="moblie-show">
              <div class="menu-btn display-flex align-center justify-center" @click="isHide = !isHide">
                <i class="el-icon-more" :class="{'el-icon-more-90': !isHide}" style="color: #2469b7;"></i>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- pc菜单栏 -->
        <el-menu :default-active="current" :router="true" class="el-menu-demo pc-show" mode="horizontal" background-color="transparent" @select="handleSelect">
          <el-menu-item  v-for='(item,index) in arr' :key="item.id" :index="item.id" @click="clickGo(item)">{{item.name}}</el-menu-item>
        </el-menu>
        <!-- 手机菜单栏 -->
         <div :class="{'mobile-menu-show': !isHide, 'mobile-menu-hide': isHide}">
           <el-menu :default-active="current" :router="true" class="el-menu-demo" mode="horizontal" background-color="transparent" @select="handleSelect">
             <el-menu-item  v-for='(item,index) in arr' :key="item.id" :index="item.id" @click="clickGo(item)">{{item.name}}</el-menu-item>
           </el-menu>
         </div>

      </el-header>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'public-head',
  data() {
    return {
      input: '',
      ruleFormSearch: {
          input: '',
      },
      rulesSearch: {
        input: [
          { required: true, message: '请输入关键词', trigger: 'blur' },
          { max: 20, message: '关键词不能超过 20 个字符', trigger: 'blur' }
        ]
      },
	  current:'1',
    arr: [{
        name: "首页",
        id: '1',
        path: '/'
      },
      {
        name: "饲料原料加工术语",
        id: '2',
        path: '/term'
      },
      {
        name: "饲料原料目录",
        id: '3',
        path: '/material',
      },
      {
        name: "饲料添加剂品种目录",
        id: '4',
        path: '/varieties'
      }
    ],
    isHide: true,
    };
  },
  watch: {
	  $route: {
	    handler(newName, oldName) {
	      　this.getPath()
	    },
	    immediate: true
	  }
  },
  methods: {
	getPath(){
		if(this.$route.query.current){
			this.current = this.$route.query.current
		}
		if(this.$route.path === '/'){
			this.current = '1'
		}
		if(this.$route.path === '/term'){
			this.current = '2'
		}
		if(this.$route.path === '/material'){
			this.current = '3'
		}
		if(this.$route.path === '/varieties'){
			this.current = '4'
		}
		this.$forceUpdate()
	},
    handleSelect(index) {
      console.log(index);
    },
    // 跳转页面方法
    clickGo(item){
      this.isHide = true
      this.$router.push({path:item.path, query: {name:item.name}});
    },
    submitForm(ruleFormSearch) {
      this.$refs[ruleFormSearch].validate((valid) => {
        if (valid) {
          this.$router.push({name:"search",params:{keyword: this.ruleFormSearch.input },query:{k:this.ruleFormSearch.input.toUpperCase()}})
          //this.$router.push(`/search/${this.ruleFormSearch.input}?k=${this.ruleFormSearch.input.toUpperCase()}`)
        } else {
          this.$message.error('请输入正确的搜索内容');
          return false;
        }
      });
    }
  }

}
</script>

<style scoped>
.public-head{
  text-align: center;
  background-color: #2469b7;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, .1);
  -webkit-box-shadow: 0px 3px 20px rgba(0, 0, 0, .1);
}
.el-header{
  position: relative;
  height: auto !important;
}
h1{
height: 30px;
font: 600 22px/30px PingFang SC;
color: #FFFFFF;
text-align: left;
}
.el-header /deep/ .el-input__inner {
  height: 30px;
}
.el-header .el-button{
  width: calc(100% - 8px);
  padding: 0;
  line-height: 28px;
  margin-left: 8px;
}
.el-header /deep/ .el-input__inner, .el-header .el-button{
  margin-top: 22px;
}
.el-header /deep/ .el-button span{
  color: #2469B7;
}
.el-menu--horizontal > .el-menu-item {
  margin-right: 20px;
  height: 30px;
  min-width: 126px;
  line-height: 32px;
  margin-top: 10px;
  color: #fff;
  font-size: 16px;
  border-radius: 4px 4px 0 0;
  background-color: #1F599B !important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #2469B7;
  background-color: #fff !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #2469B7;
  border-bottom: 0;
  background-color: #fff !important;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0;
}
.addBtn .el-button--primary {
  color: #2469B7;
  background-color: #fff;
  border-color: #fff;
}
.addBtn /deep/ .el-form--inline .el-form-item {
  margin-right: 0;
  width: 100%;
}
.addBtn /deep/ .el-form-item__content {
    width: 100%;
}
.el-form-item {
  margin-bottom: 10px;
}

.moblie-search .grid-content{
  width: 100%;
}
.mobile-menu-hide{
  height: 0;
  overflow: hidden;
  transition: height 0.5s ease-out;
}
.mobile-menu-show{
  height: 188px;
  overflow: hidden;
  transition: height 0.5s ease-out;
}
@media screen and (max-width:750px) {
  /* .public-head{
    position: sticky;
    top: 0;
    z-index: 99;
  } */
  .moblie-title,
  .moblie-search{
    width: 100%;
  }
  .moblie-search{
    padding-bottom: 20px;
  }
  .moblie-search .grid-content{
    width: calc(100% - 50px);
  }
  .moblie-search .grid-content .el-col.el-col-6{
    display: flex;
    align-items: center;
  }
  .menu-btn{
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 4px;
  }
  .el-header /deep/ .el-input__inner,
  .el-header .el-button{
    margin-top: 0;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  h1{
    font: 600 20px/28px PingFang SC;
  }
 .addBtn /deep/ .el-form-item__content{
    line-height: normal;
  }
  .el-menu--horizontal{
    /* padding-bottom: 20px; */
  }
  .el-menu--horizontal > .el-menu-item {
    margin-right: 0;
    height: 32px;
    width: 100%;
    line-height: 32px;
    margin-top: 10px;
    color: #fff;
    border-radius: 0;
  }
  .el-icon-more{
    transform: rotate(0deg);
    transition: all 0.3s ease-out;
  }
  .el-icon-more-90{
    transform: rotate(90deg);
    transition: all 0.3s ease-out;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue